import { defineStore } from 'pinia';
import { ref, readonly, computed, type Ref } from 'vue';
import { PATH_DICTIONARY } from './constants';
import { useLocalStorage } from '@vueuse/core';

const useAuthStore = defineStore('auth', () => {
  const redirectPathAfterLogin = ref(PATH_DICTIONARY.home);
  const authToken: Ref<string | null> = useLocalStorage('authToken', null);
  const isAuth = computed(() => Boolean(authToken.value));
  const redirectFromExternalDomain = ref();

  const setRedirectAfterLogin = (redirectPath = PATH_DICTIONARY.home): void => {
    redirectPathAfterLogin.value = redirectPath;
  };

  const setRedirectFromExternalDomain = (domain: string | undefined): void => {
    redirectFromExternalDomain.value = domain;
  };

  const setAuthToken = (token: string | null): void => {
    authToken.value = token;
  };

  const clearAuthToken = (): void => {
    authToken.value = null;
  };

  const getAuthToken = (): string | null => authToken.value;

  return {
    setRedirectAfterLogin,
    setRedirectFromExternalDomain,
    setAuthToken,
    clearAuthToken,
    getAuthToken,
    redirectPathAfterLogin: readonly(redirectPathAfterLogin),
    redirectFromExternalDomain: readonly(redirectFromExternalDomain),
    isAuth,
  };
});

export default useAuthStore;
